import { TableEmptyState } from '@practium/ui';
import type { PlantAnalysis } from '../../../types/analyses.types';
import { ANALYSIS_CULTURE_OPTIONS } from '../../../constants/analyses.constants';
import { formatIsoDate, resolveLabel } from '../../../utils/analysisFormatters';
import styles from '../AnalysesTable.module.css';

interface PlantAnalysisTableProps {
	analyses: PlantAnalysis[];
	onRowClick?: (id: string) => void;
}

const STATUS_CLASS: Record<string, string> = {
	Pendente: styles.statusPending,
	Realizada: styles.statusDone,
	'A vencer': styles.statusUpcoming,
};

export const PlantAnalysisTable = ({ analyses, onRowClick }: PlantAnalysisTableProps) => {
	if (analyses.length === 0) {
		return (
			<TableEmptyState
				title="Nenhuma análise foliar encontrada"
				subtitle="Adicione uma nova análise para visualizá-la aqui"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Título</th>
						<th>Cultura</th>
						<th>Região</th>
						<th>Data da Coleta</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{analyses.map((analysis) => (
						<tr
							key={analysis._id}
							onClick={() => onRowClick?.(analysis._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{analysis.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{resolveLabel(ANALYSIS_CULTURE_OPTIONS, analysis.culture)}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{analysis.region ?? '—'}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{formatIsoDate(analysis.sampleAt)}</span>
							</td>
							<td>
								<span
									className={`${styles.statusBadge} ${STATUS_CLASS[analysis.status] ?? ''}`}
								>
									{analysis.status}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
